import React from "react";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

export const DnDXmlZipFile = ({ setFormDataState }) => {
  const uploadProps = {
    name: "file",
    multiple: false,
    beforeUpload(file) {
      // Allowed file types: XML and ZIP
      const allowedTypes = [
        "application/xml", // XML
        "text/xml", // XML
        "application/zip", // ZIP
        "application/x-zip-compressed", // ZIP (alternative MIME type)
      ];

      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid file type.`);
        return Upload.LIST_IGNORE;
      }

      const isSizeValid = file.size / 1024 / 1024 < 100; // Check if the file size is under 100MB
      if (!isSizeValid) {
        message.error(`${file.name} exceeds the size limit.`);
        return Upload.LIST_IGNORE;
      }

      // Convert file to a readable format for further processing
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormDataState(file);
      };
      reader.readAsArrayBuffer(file); // Read ZIP files properly

      return false; // Prevent automatic upload
    },
  };

  return (
    <Upload.Dragger {...uploadProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        Click or drag a file to this area to upload
      </p>
      <p className="ant-upload-hint">
        Only .zip files containing xml files are allowed. One file at a time.
      </p>
    </Upload.Dragger>
  );
};
